import { render, staticRenderFns } from "./AdministrationOption.vue?vue&type=template&id=1ab710ee&scoped=true&"
import script from "./AdministrationOption.vue?vue&type=script&lang=js&"
export * from "./AdministrationOption.vue?vue&type=script&lang=js&"
import style0 from "./AdministrationOption.vue?vue&type=style&index=0&id=1ab710ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab710ee",
  null
  
)

export default component.exports